const CardSuccess = ({ className = '' }) => (
  <svg
    className={className}
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.6667 21.2H5.20008C3.80008 21.2 2.66675 20.0667 2.66675 18.6667V6.53333C2.66675 5.13333 3.80008 4 5.20008 4H25.4667C26.8667 4 28.0001 5.13333 28.0001 6.53333V13.3333'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.5719 10.628C18.8079 11.864 18.8079 13.8693 17.5719 15.1066C16.3359 16.3426 14.3306 16.3426 13.0933 15.1066C11.8573 13.8706 11.8573 11.8653 13.0933 10.628C14.3306 9.39062 16.3359 9.39062 17.5719 10.628'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M24.0001 27.9999C21.0547 27.9999 18.6667 25.6119 18.6667 22.6666C18.6667 19.7213 21.0547 17.3333 24.0001 17.3333C26.9467 17.3333 29.3334 19.7213 29.3334 22.6666C29.3334 25.6119 26.9467 27.9999 24.0001 27.9999'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.00008 17.3334H6.66675'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M24.0001 7.99992H22.6667'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M26.3707 21.4814L23.4081 24.4441L21.6294 22.6668'
      stroke='#00A067'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default CardSuccess
